import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vue3EasyDataTable from 'vue3-easy-data-table';
import vueAwesomeSidebar from 'vue-awesome-sidebar';
import vue3Shortkey from 'vue3-shortkey';
import 'vue3-easy-data-table/dist/style.css';
import 'vue-awesome-sidebar/dist/vue-awesome-sidebar.css';
import 'bootstrap';
import { CONSTANTS } from '@/constants'
import internal from '@/directives/internal'

const app = createApp(App);
app.use(store);
app.use(router);
app.use(vueAwesomeSidebar);
app.use(vue3Shortkey);
app.component('EasyDataTable', Vue3EasyDataTable);
app.config.globalProperties.$const = CONSTANTS;
app.directive('internal', internal)
app.mount('#app');

// Remove foco de qualquer elemento interno ao fechar modais para evitar o aviso do Chrome:
// "Blocked aria-hidden on an element because its descendant retained focus"
if (typeof window !== 'undefined') {
  document.addEventListener('hide.bs.modal', (e) => {
    if (document.activeElement && (e.target as HTMLElement)?.contains(document.activeElement)) {
      (document.activeElement as HTMLElement).blur();
    }
  });
}

